var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMesure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    fill: "#eac418",
    stroke: "#eac418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEE187"
    },
    d: "M256.001,14.322c-85.428,0-154.68,69.252-154.68,154.68s69.252,154.68,154.68,154.68 s154.68-69.252,154.68-154.68S341.427,14.322,256.001,14.322z M298.092,233.774l-42.092-22.129l-42.092,22.129l8.039-46.869 l-34.052-33.193l47.06-6.839l21.046-42.643l21.046,42.643l47.06,6.839l-34.055,33.193L298.092,233.774z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC61B"
    },
    d: "M387.261,315.369c-7.91,0-14.322,6.412-14.322,14.322v93.905l-43.309-29.161 c-4.835-3.255-11.161-3.255-15.999,0l-43.307,29.161v-53.293c0-7.91-6.412-14.322-14.322-14.322 c-7.91,0-14.322,6.412-14.322,14.322v100.464l-43.309-29.16c-4.834-3.255-11.161-3.257-15.998,0l-43.309,29.161V290.898 c30.382,29.159,71.602,47.106,116.938,47.106c93.187,0,169.002-75.815,169.002-169.002S349.188,0,256.001,0 S86.999,75.815,86.999,169.002c0,31.275,8.55,60.587,23.42,85.74v242.937c0,5.293,2.92,10.156,7.594,12.644 c4.672,2.485,10.335,2.194,14.728-0.763l57.631-38.805L248,509.56c2.409,1.621,5.2,2.442,8,2.442c2.306,0,4.619-0.556,6.729-1.679 c4.673-2.488,7.594-7.349,7.594-12.644v-39.548l51.308-34.548l57.631,38.805c2.409,1.621,5.2,2.442,8,2.442 c2.306,0,4.619-0.556,6.729-1.679c4.673-2.488,7.594-7.349,7.594-12.644V329.693C401.583,321.781,395.171,315.369,387.261,315.369z M256.001,28.644c77.394,0,140.358,62.963,140.358,140.358s-62.963,140.358-140.358,140.358s-140.358-62.963-140.358-140.358 S178.606,28.644,256.001,28.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC61B"
    },
    d: "M206.559,191.905l-6.766,39.448c-0.922,5.372,1.286,10.803,5.697,14.009 c4.411,3.204,10.258,3.628,15.083,1.09l35.427-18.625l35.427,18.625c2.095,1.101,4.384,1.644,6.663,1.644 c2.969,0,5.925-0.922,8.42-2.736c4.411-3.204,6.62-8.635,5.697-14.009l-6.766-39.448l28.662-27.938 c3.904-3.805,5.309-9.497,3.625-14.682c-1.684-5.185-6.167-8.963-11.562-9.748l-39.608-5.756l-17.714-35.891 c-2.413-4.888-7.392-7.983-12.843-7.983c-5.451,0-10.431,3.095-12.843,7.983l-17.714,35.891l-39.608,5.756 c-5.395,0.783-9.877,4.563-11.562,9.748c-1.684,5.185-0.279,10.876,3.625,14.682L206.559,191.905z M237.014,161.046 c4.665-0.677,8.698-3.608,10.783-7.834l8.204-16.621l8.204,16.621c2.087,4.226,6.118,7.157,10.783,7.834l18.342,2.665 l-13.272,12.937c-3.376,3.29-4.917,8.03-4.119,12.677l3.134,18.267l-16.406-8.623c-2.087-1.097-4.375-1.646-6.664-1.646 s-4.579,0.549-6.664,1.646l-16.406,8.623l3.134-18.267c0.798-4.646-0.743-9.387-4.119-12.677l-13.272-12.937L237.014,161.046z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesure);
export default __webpack_public_path__ + "static/media/mesure.4c51ae2dd6e49662d0778706d2727dd0.svg";
export { ForwardRef as ReactComponent };